import classNames from 'classnames';

import {
  CTA_TYPE,
  Heading,
  HEADING_SIZE,
  HEADING_TAG,
  ListComponentV3,
  LIST_VARIANT,
  MainBanner,
  PageSection,
  SecondaryBanner,
  SECONDARY_BANNER_VARIANT,
  SECTION_THEME,
  useDeviceSize,
} from '@amzn/sss-website-theme';

import { ROUTES } from 'src/enums/Routes';
import { getImageRoot, t } from 'src/helpers';

// eslint-disable-next-line no-restricted-imports
import styles from '../Btf.module.scss';

enum SECTION_IDS {
  CARBON_STANDARD = 'carbon-standard',
  MEASUREMENT = 'measurement',
}

interface MaritimeFuelsBtfProps {
  productDetailsBundle: any;
}

export const MaritimeFuelsBtf = ({ productDetailsBundle }: MaritimeFuelsBtfProps) => {
  const { isSmallDesktop } = useDeviceSize();
  const imageRoot = getImageRoot(isSmallDesktop);

  return (
    <>
      <PageSection>
        <Heading className={styles.learnMoreHeading} as={HEADING_TAG.H3} size={HEADING_SIZE.h3}>
          {t(productDetailsBundle, 'lowerCarbonFuels_learnMoreHeading')}
        </Heading>
        <ListComponentV3
          theme={SECTION_THEME.Light_Spruce}
          items={[
            {
              title: t(productDetailsBundle, 'lowerCarbonFuels_title'),
              subtitle: t(productDetailsBundle, 'lowerCarbonFuels_subtitle'),
              image: {
                src: `${imageRoot}/LCF-segment-1.jpg`,
                alt: t(productDetailsBundle, 'lowerCarbonFuels_containerShip_alt'),
              },
              cta: {
                href: ROUTES.CREDITS_SEGMENT_LOWER_CARBON_FUELS,
                type: CTA_TYPE.Link,
                forceServerSideNav: false,
              },
              label: t(productDetailsBundle, 'learnMore_exploreScience'),
              theme: SECTION_THEME.Light_Spruce,
              variant: LIST_VARIANT.Accordion,
              exploreCopy: t(productDetailsBundle, 'learnMore_explore'),
              newTabCopy: t(productDetailsBundle, 'learnMore_newTab'),
              pdfCopy: t(productDetailsBundle, 'learnMore_pdf'),
            },
          ]}
        />
      </PageSection>
      <PageSection className={classNames(styles.pageSection)} theme="medium-spruce" id={SECTION_IDS.CARBON_STANDARD}>
        <SecondaryBanner
          imagePrimary={{
            src: `${imageRoot}/LCF-standard-1.jpg`,
            alt: t(productDetailsBundle, 'lowerCarbonFuels_labPerson_alt'),
          }}
          imageSecondary={{
            src: `${imageRoot}/LCF-standard-2.jpg`,
            alt: t(productDetailsBundle, 'lowerCarbonFuels_ISCCLogo_alt'),
          }}
          title={t(productDetailsBundle, 'lowerCarbonFuels_ISCCMethodology_title')}
          subTitle=""
          description={t(productDetailsBundle, 'maritimeFuels_ISCCMethodology_description')}
          theme={SECTION_THEME.Sustainability_Spruce}
          cta={{
            label: t(productDetailsBundle, 'carbonStandard_cta'),
            link: 'https://iscc-system.org/certification/certification-schemes/iscc-eu/',
          }}
          variant={SECONDARY_BANNER_VARIANT.LEFT}
        />
      </PageSection>

      <PageSection id={SECTION_IDS.MEASUREMENT} theme="light-spruce">
        <MainBanner
          image={{
            src: `${imageRoot}/LCF-MRV-1.jpg`,
            alt: t(productDetailsBundle, 'lowerCarbonFuels_trucks_alt'),
          }}
          theme={SECTION_THEME.Sustainability_Spruce}
          title={t(productDetailsBundle, 'maritimeFuels_measurement_title')}
          subtitle={t(productDetailsBundle, 'maritimeFuels_measurementIscc_subtitle')}
          accordions={[
            {
              title: t(productDetailsBundle, 'measurement_measurement'),
              content: [
                {
                  text: t(productDetailsBundle, 'lowerCarbonFuels_measurementIscc_content'),
                },
              ],
            },
            {
              title: t(productDetailsBundle, 'measurement_reporting'),
              content: [
                {
                  text: t(productDetailsBundle, 'lowerCarbonFuels_reportingIscc_content'),
                },
              ],
            },
            {
              title: t(productDetailsBundle, 'measurement_verification'),
              content: [
                {
                  text: t(productDetailsBundle, 'lowerCarbonFuels_verificationIscc_content'),
                },
              ],
            },
          ]}
        />
      </PageSection>
    </>
  );
};
